import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["result"]

  greet() {
    this.resultTarget.textContent = "Hello, Stimulus!"
  }
}
